








































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { LineStopSyncCreateForm } from "../forms/LineStopSyncCreateForm";
import { Line } from "../models/Line";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => LineStopSyncCreateForm
    },
    shops: {
      type: Array as () => Line[]
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel("shop", "isStartImmediately", "fromDate", "untilDate"),
    isUpdateState() {
      return (this as any).state === "UPDATE";
    },
    shopError() {
      return (this as any).validations.shop.$error
        ? "shop is required or invalid"
        : "";
    },
    fromDateError() {
      return (this as any).validations.fromDate.$error
        ? "from date is required or invalid"
        : "";
    },
    untilDateError() {
      return (this as any).validations.untilDate.$error
        ? "until date is required or invalid"
        : "";
    }
  }
});
